export const VERSION = '4.12.4'; // x-release-please-version
//# sourceMappingURL=version.mjs.map